export default "__VITE_ASSET__1JKMJnSo__"